import axios from 'axios';
import getJWT from './token';

let api = `https://api.${process.env.REACT_APP_BASE_URL || "mattk.commerce-ims.com"}`;

const auditHelpers = {

    getFullyShippedOrders: async (startDate, endDate, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/audits/shipped-orders-by-date-range?startdate=${startDate}&enddate=${endDate}`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers });
            return {
                success: true,
                fully_shipped: res.data.fully_shipped || []
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

};




export default auditHelpers;